export default __webpack_public_path__ + "static/media/team-2.a316454a.png";